import { Button, Space, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { ManageFooter, StyledDrawer, FlowTitle } from './styled';
import { FlexFill } from '../../../common/Utils/Layout';
import apptracker from '@src/utils/sensor/apptracker';
import { ADD_OVERVIEW_FLOW } from '@src/utils/sensor/track';
import { OVERVIEW_FLOW_MAX_COUNT } from '../utils/constants';
import { selectedFlowsAtom, updateFlowOrderAtom } from '../../atoms';
import useFlowOverview from '../../hooks/useFlowOverview';
import { useAtom } from 'jotai';
import DrawerCard from './DrawerCard';
const { Text } = Typography;

const trackFlows = (flows) => {
  apptracker(ADD_OVERVIEW_FLOW, {
    flows,
  });
};

function FlowControl() {
  const { flows } = useFlowOverview();
  const [selected, setSelected] = useAtom(selectedFlowsAtom);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setSelected(flows);
    }
  }, [open, setSelected]);

  const handleClick = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setSelected([]); // reset state
  };

  const onClear = () => {
    setSelected([]);
  };

  // Get the update atom
  const [, updateOrder] = useAtom(updateFlowOrderAtom);

  const applyWidgets = () => {
    // Update flow order - persistence is handled automatically at the dashboard level
    updateOrder(selected);
    trackFlows(selected);

    // Close the drawer
    onClose();
  };

  const renderDrawerTitle = () => {
    const count = selected.length;
    return (
      <FlowTitle>
        <div className="flow-title-wrapper">
          Flows{' '}
          <Text
            type={count > OVERVIEW_FLOW_MAX_COUNT ? 'warning' : undefined}
            className="flow-drawer-title"
          >
            {' '}
            {count}/{OVERVIEW_FLOW_MAX_COUNT} Added{' '}
          </Text>
        </div>
        <Button onClick={() => window.open('/app/activation/workflow/flow/new', '_blank')}>
          Create Flow
        </Button>
      </FlowTitle>
    );
  };

  const footer = (
    <ManageFooter>
      <Button onClick={onClear} disabled={selected.length === 0}>
        Clear All
      </Button>
      <FlexFill />
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={applyWidgets}
        type="primary"
        disabled={selected.length === 0 || selected.length > OVERVIEW_FLOW_MAX_COUNT}
      >
        Apply
      </Button>
    </ManageFooter>
  );

  return (
    <>
      <Space>
        <Button onClick={handleClick} icon={<PlusOutlined />}>
          Flow
        </Button>
      </Space>
      <StyledDrawer
        title={renderDrawerTitle()}
        placement="right"
        onClose={onClose}
        open={open}
        footer={footer}
        destroyOnHidden={true}
      >
        <DrawerCard isDrawerOpen={open} />
      </StyledDrawer>
    </>
  );
}

export default FlowControl;
